import { filter } from "@wordpress/icons";
import jump from "./jump";
import checkIfOpen from "./checkIfOpen";

let noopen = false;

let triggerHandler: EventListener = (event: Event) => {
    if (event.target instanceof HTMLElement) {
        event.preventDefault();

        let filterBlock = event.target?.closest('.wp-block-taxonomy-filter-filter');
        let parentBlock = event.target?.closest('.wp-block-taxonomy-filter-filtered-posts');

        if(!noopen) {
            filterBlock?.classList.toggle('open');
        }
        
        if(parentBlock instanceof HTMLElement) {
            checkIfOpen(parentBlock);
        }

        if(filterBlock?.classList.contains('open')) {
            let selector = filterBlock?.querySelector('.taxonomy-filter-selector>li');
            if(selector instanceof HTMLElement) {
                selector.focus();
            }
        }
    }
}

let focusHandler: EventListener = (event: Event) => {
    if(event.target instanceof HTMLElement) {
        let selector: HTMLElement|null = null
        if(event.target.classList.contains('taxonomy-filter-selector')) {
            selector = event.target;
        } else {
            selector = event.target.closest('.taxonomy-filter-selector');
        }

        if(selector != null) {
            if(!selector.matches(':focus-within') && !selector.matches(':focus')) {
                let filterBlock = event.target?.closest('.wp-block-taxonomy-filter-filter');
                if(!filterBlock?.matches(':focus') && !filterBlock?.matches(':focus-within')) {
                    filterBlock?.classList.remove('open');
                    noopen = true;
                    setTimeout(() => {
                        noopen = false;
                    }, 100);
                }
            }
        }

        let parentBlock = event.target?.closest('.wp-block-taxonomy-filter-filtered-posts');
        if(parentBlock instanceof HTMLElement) {
            checkIfOpen(parentBlock);
        }       
    }
}

let init = () => {
    let triggers = document.getElementsByClassName('taxonomy-filter-trigger');

    for(let trigger of triggers) {
        trigger.addEventListener('click',triggerHandler);
    }

    let selectors = document.getElementsByClassName('taxonomy-filter-selector');

    for(let selector of selectors) {
        selector.addEventListener('focusout',focusHandler);
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}

export {};
  